"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
const colors_1 = require("../../common/colors");
const AppText_1 = require("../AppText");
const useDevice_1 = require("../../hooks/useDevice");
const native_1 = require("@react-navigation/native");
const BigButton_1 = __importDefault(require("../GradientButton/BigButton"));
const AddSources_1 = __importDefault(require("../AddSources"));
const document_1 = require("../../store/selectors/document");
const react_redux_1 = require("react-redux");
const FeatureCard = ({ icon, title, description, buttonTitle, onPress, gradientColors, buttonGradientColors }) => {
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.featureCardContainer, isMobileScreen && styles.featureCardMobile], children: [(0, jsx_runtime_1.jsx)(react_native_linear_gradient_1.default, { style: styles.iconGradientWrapper, colors: gradientColors, useAngle: true, angle: 204.43, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: icon, size: 24, color: colors_1.Colors.PRIMARY_BLUE }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.featureTextContainer, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.featureTitle, children: title }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.featureDescription, children: description })] }), (0, jsx_runtime_1.jsx)(BigButton_1.default, { fullWidth: true, containerStyle: styles.buttonItem, onPress: onPress, customGradientColors: buttonGradientColors, style: buttonGradientColors === colors_1.Colors.GRADIENT_DARK ? { borderWidth: 1, borderColor: colors_1.Colors.PRIMARY_BLUE } : undefined, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.buttonContent, children: (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.buttonText, children: buttonTitle }) }) })] }));
};
const NoDocument = () => {
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    const navigation = (0, native_1.useNavigation)();
    const [isGenerationModalOpen, setIsGenerationModalOpen] = (0, react_1.useState)(false);
    const wasDocumentUploadCompleted = (0, react_redux_1.useSelector)(document_1.selectDocumentUploadComplete);
    const features = [
        {
            icon: pro_solid_svg_icons_1.faCloudArrowUp,
            title: "Import documents",
            description: "Upload or use URLs to import docs and videos!",
            buttonTitle: wasDocumentUploadCompleted !== undefined && !wasDocumentUploadCompleted
                ? 'Uploading Document...'
                : 'Upload Document',
            onPress: () => {
                if (isMobileScreen) {
                    navigation.navigate('AddSources');
                }
                else {
                    setIsGenerationModalOpen(true);
                }
            },
            gradientColors: [colors_1.Colors.GRADIENT_DARK[0] + '80', colors_1.Colors.GRADIENT_DARK[1] + '80'],
            buttonGradientColors: colors_1.Colors.GRADIENT
        },
        {
            icon: pro_solid_svg_icons_1.faBooks,
            title: "Explore library",
            description: "Discover our curated library of documents",
            buttonTitle: "Browse Library",
            onPress: () => {
                navigation.navigate("Home", { screen: "Library" });
            },
            gradientColors: [colors_1.Colors.GRADIENT_DARK[0] + '80', colors_1.Colors.GRADIENT_DARK[1] + '80'],
            buttonGradientColors: colors_1.Colors.GRADIENT_DARK
        },
    ];
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.view, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { gap: 8 }, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: [styles.title, isMobileScreen && styles.titleMobile], children: "Knowledge is Power" }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: [styles.headerText, isMobileScreen && styles.headerTextMobile], children: isMobileScreen ?
                            'Turn files, links or videos into an\n interactive knowledge base in seconds' :
                            'Turn file, links or videos into an interactive knowledge base in seconds' })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.featuresContainer, isMobileScreen && styles.featuresContainerMobile], children: features.map((feature, index) => ((0, jsx_runtime_1.jsx)(FeatureCard, { ...feature }, index))) }), (0, jsx_runtime_1.jsx)(AddSources_1.default, { isOpen: isGenerationModalOpen, onClose: () => setIsGenerationModalOpen(false) })] }));
};
const styles = react_native_1.StyleSheet.create({
    featureCardContainer: {
        flex: 1,
        borderRadius: 12,
        padding: 16,
        gap: 16,
        alignItems: 'center',
        backgroundColor: `${colors_1.Colors.white}10`,
    },
    featureCardMobile: {
        flex: 1,
        width: '100%',
        marginBottom: 8
    },
    buttonItem: {
        marginTop: 8,
        borderRadius: 64,
        alignItems: 'center',
        alignSelf: 'center',
    },
    buttonContent: {
        flexDirection: 'row',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        gap: 8
    },
    iconGradientWrapper: {
        width: 48,
        height: 48,
        borderRadius: 12,
        justifyContent: 'center',
        alignItems: 'center'
    },
    featureTextContainer: {
        gap: 8,
        alignItems: 'center',
        flex: 1,
    },
    featureTitle: {
        fontSize: 20,
        fontWeight: '900',
        color: colors_1.Colors.white,
        textAlign: 'center'
    },
    featureDescription: {
        fontSize: 14,
        color: colors_1.Colors.DARK_100,
        textAlign: 'center',
    },
    headerText: {
        fontSize: 14,
        textAlign: "center",
        color: colors_1.Colors.DARK_100,
    },
    headerTextMobile: {
        fontSize: 16,
        lineHeight: 28,
        textAlign: "center",
        color: colors_1.Colors.DARK_100,
    },
    title: {
        fontSize: 32,
        fontWeight: '700',
        textAlign: "center",
        color: colors_1.Colors.PRIMARY_BLUE,
    },
    titleMobile: {
        fontSize: 40,
        lineHeight: 40,
        textAlign: "center",
        color: colors_1.Colors.PRIMARY_BLUE,
    },
    featuresContainer: {
        gap: 8,
        justifyContent: "center",
        flexDirection: "row",
    },
    featuresContainerMobile: {
        flexDirection: "column",
        justifyContent: "center",
    },
    buttonText: {
        color: colors_1.Colors.white,
        textAlign: "center",
        fontWeight: "500",
        fontSize: 16,
        lineHeight: 20,
        alignSelf: 'center'
    },
    view: {
        borderRadius: 24,
        backgroundColor: `${colors_1.Colors.white}10`,
        paddingHorizontal: 20,
        paddingVertical: 32,
        marginVertical: 64,
        gap: 24,
        alignContent: "center",
        justifyContent: 'center',
    }
});
exports.default = NoDocument;
